module.exports = __webpack_public_path__ + "static/media/pickles-anais-andrew-as-fates.59a3535d.jpg";